import React, { useState } from "react";
import "./CandLogin.css";
import logo from "../../assets/images/hire_form_logo.png";
import { useCandidateLoginMutation } from "../../slice/authApiSlice";
import { useDispatch } from "react-redux";
import { setCredentials } from "../../slice/authSlice";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { IoMdClose } from "react-icons/io";
import CandRegister from "../candidate_register/CandRegister";

const CandLogin = ({ onClose, onSubmit }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [login, { isLoading }] = useCandidateLoginMutation();
  const [candModalOpen, setCandModalOpen] = useState(false);
  const [forgotOpen, setForgotOpen] = useState(false);

  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  };

  const loginHandler = async () => {
    const payload = {
      email,
      password,
    };

    if (email === "") {
      toast.error("Email is required");
    } else if (!validateEmail(email)) {
      toast.error("Invalid email format");
    } else if (password === "") {
      toast.error("Password is required");
    } else {
      try {
        const res = await login(payload).unwrap();

        dispatch(
          setCredentials({
            userInfo: res.user,
            token: res.token,
          })
        );

        toast.success("Login successful 🎉");
        navigate("/"); // redirect to home page
      } catch (error) {
        toast.error(error?.data?.message || "Login failed");
      }
    }
  };

  const handleCandModalClick = () => {
    setCandModalOpen(!candModalOpen);
  };

  const handleForgotClick = () => {
    setForgotOpen(!forgotOpen);
  };

  return (
    <div className="cand_login_section">
      {candModalOpen && (
        <CandRegister
          onClose={handleCandModalClick}
          onSubmit={handleCandModalClick}
        />
      )}
      <div className="cand_login_container">
        <div className="cand_login_left_side">
          <div className="cand_login_heading_section">
            <div className="logo_img_container">
              <img src={logo} alt="logo" />
            </div>
            <div className="cand_login_heading_container">
              <h2>Explore 5 lakh+ career opportunities.</h2>
            </div>
          </div>
          <div className="pnt_container">
            <p>Privacy Policy</p>
            <p>Terms & Conditions</p>
          </div>
        </div>

        <div className="cand_login_right_side">
          <div className="close_button_container">
            <button>
              <IoMdClose className="cross_icon" onClick={() => onClose()} />
            </button>
          </div>
          <div className="rightside_heading_and_form_container">
            <h2>Welcome, glad to see you!</h2>
            <div className="cand_login_right_side_form_container">
              <form className="cand_login_right_side_form">
                <div className="cand_login_right_side_form_input_container">
                  <label>Candidate Email id</label>
                  <input
                    type="email"
                    placeholder="Email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>
                <div className="cand_login_right_side_form_input_container">
                  <label>Password</label>
                  <input
                    type="password"
                    placeholder="Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                </div>
                <div className="f_password_section">
                  <a onClick={handleForgotClick}>Forgot Password?</a>
                </div>
              </form>
            </div>

            <div className="cand_login_button_container">
              <button onClick={loginHandler} disabled={isLoading}>
                {isLoading ? "Logging in..." : "Login"}
              </button>
              <a>Login using OTP</a>
            </div>
          </div>

          <div className="create_account_section">
            <p>Don’t have an account?</p>
            <a onClick={handleCandModalClick}>
              <button>Create an Account</button>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CandLogin;

